import { consentToGoogleConsentModeUpdate } from './consentToGoogleConsentMode';
import type { OsanoConsent } from './types';

const EVENT_NAME = 'osano_consent_update';

/**
 * Push Osano consent to dataLayer for GTM / Consent Mode v2.
 *
 * Relies on `window.gtag` being defined by the SSR-injected `consent-mode-default`
 * snippet in `gatsby-ssr.jsx`. If gtag is missing we fail closed — the deny-default
 * already configured by that same snippet stays in effect, and the dedicated
 * `osano_consent_update` event still fires so GTM triggers can react.
 */
export function pushConsentToDataLayer(consent: OsanoConsent | undefined) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  const consentMode = consentToGoogleConsentModeUpdate(consent);

  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: consentMode.analytics_storage,
      ad_storage: consentMode.ad_storage,
      ad_user_data: consentMode.ad_user_data,
      ad_personalization: consentMode.ad_personalization,
    });
  }

  window.dataLayer.push({
    event: EVENT_NAME,
    osano_consent: consent ?? null,
    consent_mode: consentMode,
  });
}
